import React from 'react'

import { Loader } from 'components'

const TicketCalendarLoading: React.FC = () => {
  const base = 'ticket-calendar'

  return (
    <div className={`${base}__loading`}>
      <Loader size='lg' />
    </div>
  )
}

export default TicketCalendarLoading
